// extracted by css-extract-rspack-plugin
export default {"bg":"bg-WHAgfI"};